import { useCallback, useEffect, useRef, useState } from 'react';
import { clearDateUnit, getDateDifferenceInSeconds } from './helpers';
export const useCounter = (counterTime, onTimeOut) => {
    const startTime = useRef({
        time: clearDateUnit(),
        defaultCountDown: counterTime ?? 0,
    });
    const [isCounterRunning, setIsCounterRunning] = useState(false);
    const [countDown, setCountDown] = useState(startTime.current.defaultCountDown);
    const counterIntervalRef = useRef(null);
    const onTimetOutRef = useRef(onTimeOut);
    useEffect(() => {
        onTimetOutRef.current = onTimeOut;
    }, [onTimeOut]);
    const clearCurrentInterval = useCallback(() => {
        if (counterIntervalRef.current !== null) {
            clearInterval(counterIntervalRef.current);
            counterIntervalRef.current = null;
            setIsCounterRunning(false);
            setCountDown(0);
        }
    }, []);
    const changeCountDown = useCallback(() => {
        const dateDiff = getDateDifferenceInSeconds(clearDateUnit(), startTime.current.time);
        const newCountDown = Math.floor(startTime.current.defaultCountDown - dateDiff);
        setCountDown(newCountDown);
    }, []);
    useEffect(() => {
        if (isCounterRunning && countDown <= 0) {
            clearCurrentInterval();
            onTimetOutRef?.current?.();
        }
    }, [clearCurrentInterval, countDown, isCounterRunning]);
    const counterInterval = useCallback((val) => {
        const countdownValue = val ?? counterTime;
        if (countdownValue === undefined)
            return;
        startTime.current = {
            time: clearDateUnit(),
            defaultCountDown: countdownValue,
        };
        setCountDown(countdownValue);
        setIsCounterRunning(true);
        counterIntervalRef.current = setInterval(changeCountDown, 1000);
    }, [changeCountDown, counterTime]);
    useEffect(() => {
        clearCurrentInterval();
        if (counterTime !== undefined) {
            counterInterval();
            setIsCounterRunning(false);
        }
    }, [clearCurrentInterval, counterInterval, counterTime]);
    useEffect(() => {
        return () => {
            clearCurrentInterval();
        };
    }, [clearCurrentInterval]);
    return {
        isCounterRunning,
        setIsCounterRunning,
        countDown,
        setCountDown,
        counterInterval,
        clearCurrentInterval,
    };
};
//# sourceMappingURL=useCounter.js.map